(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-hover-video"] && !Shopify.designMode) return;
  try {
    /* Card Hover Video — created by M5 TECH */
  (() => {
    if (window.__cardHoverVideo) return;
    window.__cardHoverVideo = true;

    if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const CARD = 'product-card, .product-card';

    const start = (video) => {
      if (!video.src) video.src = video.dataset.src;
      const playPromise = video.play();
      if (playPromise) {
        playPromise
          .then(() => video.classList.add('is-playing'))
          .catch(() => {});
      }
    };

    const stop = (video) => {
      video.pause();
      video.classList.remove('is-playing');
      video.currentTime = 0;
    };

    document.addEventListener('pointerover', (e) => {
      const card = e.target.closest(CARD);
      if (!card || card.contains(e.relatedTarget)) return;
      const video = card.querySelector('.card-hover-video');
      if (video) start(video);
    });

    document.addEventListener('pointerout', (e) => {
      const card = e.target.closest(CARD);
      if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
      const video = card.querySelector('.card-hover-video');
      if (video) stop(video);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
